import { useState } from "react";
import UseCaseForm from "./UseCaseForm";
import RoleListTable from "./RoleListTable";

export default function UseCaseTabs() {
  const tabs = [
    { id: "create", label: "Company Role Creation", component: <UseCaseForm /> },
    { id: "list",   label: "Company Role List",     component: <RoleListTable /> },
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].id);

  return (
    <div className="usecase-wrapper ad-card ad-card-lg ad-animate">

      {/* Header */}
      <div className="ad-card-header usecase-header">
        <h3 className="ad-card-title">UseCase Master</h3>

        <div className="usecase-tab-buttons">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`ad-btn ${activeTab === tab.id ? "ad-btn-blue" : "ad-btn-outline"}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="usecase-content">
        {tabs.find((tab) => tab.id === activeTab)?.component}
      </div>

    </div>
  );
}